import React, {useEffect} from 'react'
import {getSize1} from 'hiya-common/src/utils'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import RocketApng from './images/apng/新火箭1.png'
import FireOneApng from './images/apng/初级火焰.png'
import FireTwoApng from './images/apng/中级火焰.png'
import FireThreeApng from './images/apng/顶级火焰.png'
import PoFeng1Apng from './images/apng/初级音爆.png'
import PoFeng2Apng from './images/apng/中级音爆.png'
import PoFeng3Apng from './images/apng/高级音爆.png'
import BoomApng from './images/apng/火箭爆炸.png'
import RightBetApng from './images/apng/右侧金币.png'
import LeftBetApng from './images/apng/左侧金币.png'
import RankBetApng from './images/apng/多人下注.png'
import TimeApng from './images/apng/倒计时.png'
import RateToCoinsApng from './images/apng/倍率飞金币.png'
import coinsChangeApng from './images/apng/个人信息金额变动.png'
import loadApng from './images/apng/loading.png'
import {betInfo, BtnStatusEnum, GameStatus} from './reducers'

// log --- 获取路径和总长度的log
const logPath = () => {
  const pathDom = document.querySelector('path')
  const total = pathDom.getTotalLength()
  const list = []
  for (let index = 0; index < total; index += 1) {
    const point = pathDom.getPointAtLength(index)
    list.push([point.x, point.y])
  }
  console.log('路径列表:', list)
}

// render --- 火箭飞行的svg
const renderRocketSvg = (onInitPath, onInitSVG) => {
  return (
    <svg
      width={`${getSize1(229)}`}
      height={`${getSize1(280)}`}
      viewBox="0 0 229 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={(ref) => {
        onInitSVG(ref)
      }}
    >
      <g filter="url(#filter0_f_468_4196)">
        <path
          d="M4 275.97C194.5 275.97 224.973 156.173 224.973 4"
          stroke="url(#paint0_linear_468_4196)"
          strokeWidth="4"
          strokeLinecap="round"
          ref={(ref) => {
            onInitPath(ref)
          }}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_468_4196"
          x="0"
          y="0"
          width="228.973"
          height="279.97"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_468_4196"
          />
        </filter>
        <linearGradient
          id="paint0_linear_468_4196"
          x1="173.245"
          y1="-42.7371"
          x2="-79.672"
          y2="288.366"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0224168" stopColor="#DF412D" />
          <stop offset="0.31355" stopColor="#FFE100" />
          <stop offset="0.87" stopColor="#FFF5D3" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}

// config --- 路径总长度列表 前x 后y
export const flyListConfig = [
  [4, 275.9700012207031],
  [4.999998569488525, 275.9687805175781],
  [5.9999918937683105, 275.9653625488281],
  [6.999975204467773, 275.9597473144531],
  [7.999942779541016, 275.951904296875],
  [8.999890327453613, 275.9418029785156],
  [9.999812126159668, 275.929443359375],
  [10.999703407287598, 275.914794921875],
  [11.999558448791504, 275.8978271484375],
  [12.999372482299805, 275.87860107421875],
  [13.999138832092285, 275.8570251464844],
  [14.998851776123047, 275.83306884765625],
  [15.99850082397461, 275.80657958984375],
  [16.99808120727539, 275.7776184082031],
  [17.997589111328125, 275.74627685546875],
  [18.99701690673828, 275.7124938964844],
  [19.99635887145996, 275.67626953125],
  [20.995607376098633, 275.63751220703125],
  [21.9947566986084, 275.5963134765625],
  [22.993799209594727, 275.5525817871094],
  [23.992725372314453, 275.50628662109375],
  [24.991531372070312, 275.45745849609375],
  [25.990205764770508, 275.40606689453125],
  [26.988744735717773, 275.35205078125],
  [27.987138748168945, 275.29541015625],
  [28.985380172729492, 275.23614501953125],
  [29.983457565307617, 275.1741943359375],
  [30.981367111206055, 275.10955810546875],
  [31.979093551635742, 275.04217529296875],
  [32.97663497924805, 274.97210693359375],
  [33.97397994995117, 274.8992919921875],
  [34.97111892700195, 274.8236999511719],
  [35.96803665161133, 274.7452697753906],
  [36.964725494384766, 274.6640319824219],
  [37.96118927001953, 274.5799560546875],
  [38.957401275634766, 274.4930419921875],
  [39.95335388183594, 274.4031982421875],
  [40.94904327392578, 274.3104553222656],
  [41.94445037841797, 274.21478271484375],
  [42.9395751953125, 274.11614990234375],
  [43.93439865112305, 274.0145568847656],
  [44.92890930175781, 273.909912109375],
  [45.923095703125, 273.80224609375],
  [46.91694641113281, 273.6915588378906],
  [47.91044998168945, 273.5777893066406],
  [48.90359878540039, 273.4609375],
  [49.89636993408203, 273.3409118652344],
  [50.888755798339844, 273.2177734375],
  [51.88074493408203, 273.0914611816406],
  [52.87232208251953, 272.96197509765625],
  [53.86347198486328, 272.8292236328125],
  [54.85417938232422, 272.6932678222656],
  [55.84444046020508, 272.5540466308594],
  [56.834232330322266, 272.4115295410156],
  [57.82353973388672, 272.2657165527344],
  [58.81235122680664, 272.1165466308594],
  [59.8006477355957, 271.9640197753906],
  [60.788421630859375, 271.8081359863281],
  [61.77565002441406, 271.6488342285156],
  [62.7623176574707, 271.486083984375],
  [63.74836349487305, 271.3196105957031],
  [64.73381805419922, 271.149658203125],
  [65.7186508178711, 270.9761657714844],
  [66.7028579711914, 270.7991943359375],
  [67.68640899658203, 270.61859130859375],
  [68.6693115234375, 270.4344482421875],
  [69.65151977539062, 270.24664306640625],
  [70.63301849365234, 270.0552062988281],
  [71.61380004882812, 269.8601379394531],
  [72.5938491821289, 269.661376953125],
  [73.57306671142578, 269.4586181640625],
  [74.55148315429688, 269.25201416015625],
  [75.52911376953125, 269.0416564941406],
  [76.50590515136719, 268.8274841308594],
  [77.48185729980469, 268.6095275878906],
  [78.45694732666016, 268.3877258300781],
  [79.43113708496094, 268.1620178222656],
  [80.40441131591797, 267.932373046875],
  [81.37665557861328, 267.69842529296875],
  [82.34794616699219, 267.46051025390625],
  [83.31825256347656, 267.2186584472656],
  [84.28755187988281, 266.9727783203125],
  [85.25582885742188, 266.722900390625],
  [86.2230453491211, 266.4689636230469],
  [87.18905639648438, 266.2104797363281],
  [88.1539535522461, 265.9478759765625],
  [89.11772155761719, 265.6811218261719],
  [90.08032989501953, 265.4102478027344],
  [91.04175567626953, 265.13519287109375],
  [92.00189971923828, 264.855712890625],
  [92.96070861816406, 264.5716552734375],
  [93.91825103759766, 264.2833557128906],
  [94.8744888305664, 263.99078369140625],
  [95.82941436767578, 263.6939392089844],
  [96.78289794921875, 263.3924865722656],
  [97.73487854003906, 263.0863342285156],
  [98.6854476928711, 262.77581787109375],
  [99.63456726074219, 262.4609069824219],
  [100.58222961425781, 262.1416320800781],
  [101.52814483642578, 261.8172607421875],
  [102.47251892089844, 261.4884033203125],
  [103.41532897949219, 261.1550598144531],
  [104.35653686523438, 260.8172302246094],
  [105.29591369628906, 260.474365234375],
  [106.2335433959961, 260.1267395019531],
  [107.16947174072266, 259.7745361328125],
  [108.10367584228516, 259.4178161621094],
  [109.03584289550781, 259.0558166503906],
  [109.9661636352539, 258.6890869140625],
  [110.89466094970703, 258.3177490234375],
  [111.82122802734375, 257.9416198730469],
  [112.74559020996094, 257.56011962890625],
  [113.66802215576172, 257.1739501953125],
  [114.58845520019531, 256.7830810546875],
  [115.50663757324219, 256.3869323730469],
  [116.42262268066406, 255.98574829101562],
  [117.3365249633789, 255.57980346679688],
  [118.24819946289062, 255.16888427734375],
  [119.15738677978516, 254.7525177001953],
  [120.06436920166016, 254.33135986328125],
  [120.96910858154297, 253.9053955078125],
  [121.8711166381836, 253.4736785888672],
  [122.77080535888672, 253.03717041015625],
  [123.66814422607422, 252.5958251953125],
  [124.56262969970703, 252.14874267578125],
  [125.45463562011719, 251.6967315673828],
  [126.34416961669922, 251.2398681640625],
  [127.230712890625, 250.7772216796875],
  [128.11465454101562, 250.30963134765625],
  [128.9959716796875, 249.83712768554688],
  [129.87411499023438, 249.35874938964844],
  [130.7495880126953, 248.87550354003906],
  [131.62220764160156, 248.38711547851562],
  [132.4916229248047, 247.89303588867188],
  [133.3582305908203, 247.39402770996094],
  [134.22169494628906, 246.8896484375],
  [135.0819549560547, 246.3798065185547],
  [135.93930053710938, 245.86505126953125],
  [136.7931671142578, 245.34457397460938],
  [137.6438751220703, 244.81895446777344],
  [138.49143981933594, 244.2882537841797],
  [139.33535766601562, 243.75177001953125],
  [140.17613220214844, 243.2104034423828],
  [141.0133056640625, 242.66346740722656],
  [141.8470001220703, 242.1112518310547],
  [142.6773681640625, 241.55404663085938],
  [143.5037841796875, 240.99099731445312],
  [144.32688903808594, 240.423095703125],
  [145.1461181640625, 239.8496551513672],
  [145.96168518066406, 239.27098083496094],
  [146.7736053466797, 238.68722534179688],
  [147.58145141601562, 238.09783935546875],
  [148.38577270507812, 237.50364685058594],
  [149.1858367919922, 236.90374755859375],
  [149.982177734375, 236.29888916015625],
  [150.77447509765625, 235.6887664794922],
  [151.5626678466797, 235.07333374023438],
  [152.34701538085938, 234.4530029296875],
  [153.12689208984375, 233.82708740234375],
  [153.9029998779297, 233.1964874267578],
  [154.6745147705078, 232.56027221679688],
  [155.44207763671875, 231.91929626464844],
  [156.20518493652344, 231.27304077148438],
  [156.96405029296875, 230.62179565429688],
  [157.7186279296875, 229.965576171875],
  [158.4686279296875, 229.3041534423828],
  [159.21449279785156, 228.6380615234375],
  [159.9555206298828, 227.96656799316406],
  [160.69247436523438, 227.29063415527344],
  [161.42440795898438, 226.60926818847656],
  [162.1521759033203, 225.9234619140625],
  [162.87506103515625, 225.23251342773438],
  [163.59352111816406, 224.53695678710938],
  [164.3072052001953, 223.8365020751953],
  [165.01625061035156, 223.13133239746094],
  [165.72061157226562, 222.42149353027344],
  [166.42010498046875, 221.70687866210938],
  [167.11502075195312, 220.98779296875],
  [167.80490112304688, 220.26388549804688],
  [168.49029541015625, 219.5357208251953],
  [169.1704559326172, 218.8026580810547],
  [169.84622192382812, 218.06552124023438],
  [170.5165557861328, 217.323486328125],
  [171.1824951171875, 216.57748413085938],
  [171.8430633544922, 215.82672119140625],
  [172.49908447265625, 215.0719757080078],
  [173.14981079101562, 214.3126678466797],
  [173.79583740234375, 213.5493621826172],
  [174.4366912841797, 212.78170776367188],
  [175.07269287109375, 212.010009765625],
  [175.70359802246094, 211.23416137695312],
  [176.32952880859375, 210.45428466796875],
  [176.95045471191406, 209.67042541503906],
  [177.56625366210938, 208.88250732421875],
  [178.1771697998047, 208.0908203125],
  [178.78280639648438, 207.2950897216797],
  [179.3837127685547, 206.49575805664062],
  [179.97918701171875, 205.69239807128906],
  [180.57000732421875, 204.88560485839844],
  [181.1553192138672, 204.07479858398438],
  [181.736083984375, 203.26072692871094],
  [182.3112030029297, 202.4426727294922],
  [182.8817901611328, 201.62144470214844],
  [183.44686889648438, 200.79641723632812],
  [184.00726318359375, 199.96820068359375],
  [184.56234741210938, 199.13641357421875],
  [185.1125946044922, 198.30140686035156],
  [185.65765380859375, 197.46302795410156],
  [186.19776916503906, 196.62142944335938],
  [186.7328643798828, 195.77664184570312],
  [187.2628936767578, 194.9286651611328],
  [187.7880859375, 194.0776824951172],
  [188.3080291748047, 193.22348022460938],
  [188.82334899902344, 192.36648559570312],
  [189.33328247070312, 191.5062713623047],
  [189.83877563476562, 190.6434326171875],
  [190.33877563476562, 189.77740478515625],
  [190.83428955078125, 188.9088134765625],
  [191.32460021972656, 188.0372772216797],
  [191.81024169921875, 187.1631317138672],
  [192.29090881347656, 186.28622436523438],
  [192.76675415039062, 185.4066925048828],
  [193.23785400390625, 184.52462768554688],
  [193.70394897460938, 183.639892578125],
  [194.16558837890625, 182.75282287597656],
  [194.6219940185547, 181.86306762695312],
  [195.07411193847656, 180.9711151123047],
  [195.52110290527344, 180.0765838623047],
  [195.96368408203125, 179.17984008789062],
  [196.40142822265625, 178.28074645996094],
  [196.83453369140625, 177.37940979003906],
  [197.26315307617188, 176.47593688964844],
  [197.68690490722656, 175.57015991210938],
  [198.10646057128906, 174.6624298095703],
  [198.52098083496094, 173.7523956298828],
  [198.9313201904297, 172.8404541015625],
  [199.3369598388672, 171.92642211914062],
  [199.73818969726562, 171.0104522705078],
  [200.1350860595703, 170.0926055908203],
  [200.5272979736328, 169.17271423339844],
  [200.9154815673828, 168.25112915039062],
  [201.29885864257812, 167.32754516601562],
  [201.6781768798828, 166.40228271484375],
  [202.05311584472656, 165.47525024414062],
  [202.4236602783203, 164.5464324951172],
  [202.790283203125, 163.61605834960938],
  [203.15220642089844, 162.68385314941406],
  [203.51025390625, 161.75015258789062],
  [203.86399841308594, 160.8148193359375],
  [204.21356201171875, 159.87791442871094],
  [204.559326171875, 158.93959045410156],
  [204.90054321289062, 157.9995880126953],
  [205.23802185058594, 157.0582733154297],
  [205.57138061523438, 156.115478515625],
  [205.9006805419922, 155.17124938964844],
  [206.22630310058594, 154.2257537841797],
  [206.5475616455078, 153.27877807617188],
  [206.8651580810547, 152.33053588867188],
  [207.178955078125, 151.3810272216797],
  [207.4886474609375, 150.43020629882812],
  [207.79481506347656, 149.4782257080078],
  [208.0970001220703, 148.52496337890625],
  [208.3954315185547, 147.57054138183594],
  [208.6904296875, 146.61505126953125],
  [208.98129272460938, 145.65829467773438],
  [209.26870727539062, 144.70050048828125],
  [209.55262756347656, 143.74163818359375],
  [209.83261108398438, 142.78164672851562],
  [210.10926818847656, 141.8206787109375],
  [210.38233947753906, 140.85870361328125],
  [210.65176391601562, 139.89569091796875],
  [210.9179229736328, 138.9317626953125],
  [211.1804656982422, 137.96682739257812],
  [211.43954467773438, 137.0009765625],
  [211.6954345703125, 136.0342559814453],
  [211.94775390625, 135.06661987304688],
  [212.1967315673828, 134.09811401367188],
  [212.44261169433594, 133.12879943847656],
  [212.68496704101562, 132.15859985351562],
  [212.92410278320312, 131.18760681152344],
  [213.16021728515625, 130.21588134765625],
  [213.3928985595703, 129.2433319091797],
  [213.6224365234375, 128.27003479003906],
  [213.84902954101562, 127.29605102539062],
  [214.0723114013672, 126.32128143310547],
  [214.29249572753906, 125.34580993652344],
  [214.50978088378906, 124.36972045898438],
  [214.72393798828125, 123.39290618896484],
  [214.9350128173828, 122.41544342041016],
  [215.14324951171875, 121.43736267089844],
  [215.3485565185547, 120.45867156982422],
  [215.5507354736328, 119.47931671142578],
  [215.75018310546875, 118.49942016601562],
  [215.9468994140625, 117.5189437866211],
  [216.1404266357422, 116.53783416748047],
  [216.33128356933594, 115.55621337890625],
  [216.5194854736328, 114.57406616210938],
  [216.70474243164062, 113.59137725830078],
  [216.8872528076172, 112.6081771850586],
  [217.0671844482422, 111.62450408935547],
  [217.2444610595703, 110.64032745361328],
  [217.41883850097656, 109.65564727783203],
  [217.5906982421875, 108.67053985595703],
  [217.7600860595703, 107.68499755859375],
  [217.9266815185547, 106.69895935058594],
  [218.09071350097656, 105.7125015258789],
  [218.2523193359375, 104.72564697265625],
  [218.41148376464844, 103.73841857910156],
  [218.56788635253906, 102.75072479248047],
  [218.721923828125, 101.76264190673828],
  [218.87362670898438, 100.77421569824219],
  [219.02285766601562, 99.78540802001953],
  [219.1695556640625, 98.7962417602539],
  [219.31398010253906, 97.8067398071289],
  [219.45614624023438, 96.81687927246094],
  [219.59585571289062, 95.82667541503906],
  [219.73318481445312, 94.8361587524414],
  [219.86831665039062, 93.8453140258789],
  [220.0012969970703, 92.85417938232422],
  [220.1318817138672, 91.86273193359375],
  [220.26019287109375, 90.87100219726562],
  [220.3863983154297, 89.87899017333984],
  [220.51051330566406, 88.88671875],
  [220.63232421875, 87.8941879272461],
  [220.751953125, 86.9013671875],
  [220.86956787109375, 85.90830993652344],
  [220.98513793945312, 84.91500854492188],
  [221.09852600097656, 83.92146301269531],
  [221.2094268798828, 82.9276351928711],
  [221.3191680908203, 81.93366241455078],
  [221.42654418945312, 80.939453125],
  [221.53195190429688, 79.94501495361328],
  [221.6351776123047, 78.95034790039062],
  [221.7365264892578, 77.95551300048828],
  [221.8359832763672, 76.96046447753906],
  [221.93357849121094, 75.96524047851562],
  [222.0286102294922, 74.96977233886719],
  [222.12281799316406, 73.97422790527344],
  [222.21469116210938, 72.97846221923828],
  [222.30429077148438, 71.98249053955078],
  [222.39308166503906, 70.98644256591797],
  [222.4788818359375, 69.99011993408203],
  [222.56365966796875, 68.99371337890625],
  [222.64651489257812, 67.99714660644531],
  [222.7273712158203, 67.00041961669922],
  [222.8072509765625, 66.00361633300781],
  [222.88433837890625, 65.006591796875],
  [222.9604034423828, 64.0094985961914],
  [223.03468322753906, 63.012264251708984],
  [223.10702514648438, 62.014888763427734],
  [223.17843627929688, 61.017452239990234],
  [223.24720764160156, 60.01982116699219],
  [223.3150177001953, 59.02212905883789],
  [223.38108825683594, 58.024314880371094],
  [223.4453582763672, 57.026397705078125],
  [223.50877380371094, 56.028411865234375],
  [223.569580078125, 55.0302734375],
  [223.62957763671875, 54.03207778930664],
  [223.68777465820312, 53.033775329589844],
  [223.74441528320312, 52.035377502441406],
  [223.8000946044922, 51.036930084228516],
  [223.85345458984375, 50.0383415222168],
  [223.90606689453125, 49.03972244262695],
  [223.956787109375, 48.04100799560547],
  [224.00621032714844, 47.04222106933594],
  [224.05450439453125, 46.04338836669922],
  [224.10081481933594, 45.044464111328125],
  [224.1464385986328, 44.04550552368164],
  [224.19000244140625, 43.04645538330078],
  [224.2326202392578, 42.04736328125],
  [224.27386474609375, 41.048213958740234],
  [224.3135223388672, 40.049007415771484],
  [224.35250854492188, 39.049766540527344],
  [224.3892822265625, 38.050453186035156],
  [224.42544555664062, 37.051109313964844],
  [224.45997619628906, 36.05170822143555],
  [224.49334716796875, 35.052249908447266],
  [224.52572631835938, 34.05277633666992],
  [224.55636596679688, 33.0532341003418],
  [224.58645629882812, 32.05367660522461],
  [224.61460876464844, 31.054073333740234],
  [224.64205932617188, 30.05445671081543],
  [224.6681365966797, 29.054798126220703],
  [224.69297790527344, 28.055099487304688],
  [224.717041015625, 27.055389404296875],
  [224.7393798828125, 26.055631637573242],
  [224.76121520996094, 25.05586051940918],
  [224.7813262939453, 24.05606460571289],
  [224.80072021484375, 23.05626678466797],
  [224.81890869140625, 22.05643081665039],
  [224.8359375, 21.05657386779785],
  [224.85223388671875, 20.05670738220215],
  [224.86692810058594, 19.056819915771484],
  [224.8811798095703, 18.056930541992188],
  [224.893798828125, 17.057010650634766],
  [224.9058074951172, 16.057086944580078],
  [224.91664123535156, 15.057147026062012],
  [224.92645263671875, 14.0571928024292],
  [224.935546875, 13.057233810424805],
  [224.94320678710938, 12.057278633117676],
  [224.9504852294922, 11.057302474975586],
  [224.95616149902344, 10.057318687438965],
  [224.96136474609375, 9.057336807250977],
  [224.9653778076172, 8.057345390319824],
  [224.96856689453125, 7.05735969543457],
  [224.970947265625, 6.0573625564575195],
  [224.97216796875, 5.057372570037842],
  [224.97296142578125, 4.057373046875],
]

// config --- 飞行总时间
const flyTimeConfig = 5000

// config --- 路径总长度，一般向上取整数 注意和列表个数一致
const flyDistanceConfig = flyListConfig.length

// config --- 飞行速度 1ms走几个路径
const flySpeedConfig = flyDistanceConfig / flyTimeConfig

// config --- 记录颜色
const recordColorConfig = [1.99, 4.99, 9.99, 100]
const recordColorTextConfig = ['blue', 'green', 'orange', 'red']
const oddsColorConfig = ['#00AEFF', '#58D776', '#FFAE00', '#FF6670']
// 时间剩余5秒开始放大特效
const timeBigConfig = 5

// get --- 获取当前飞行距离所对应的x、y坐标
const getFlyXY = (index, pathDom, gameWrapDom, viewDom) => {
  // 根据index 获取前后两个点 计算差值得到准确位置 如果
  const floorIndex = Math.floor(index)
  const curPoint = Math.min(floorIndex, flyDistanceConfig - 2)
  const viewBox = viewDom?.getAttribute('viewBox').split(' ')
  const pathRect = pathDom?.getBoundingClientRect()
  const {innerWidth} = window
  const gameWrapRect = gameWrapDom?.getBoundingClientRect()
  const point = flyListConfig[curPoint]
  const nextPoint = flyListConfig[curPoint + 1]
  const getXY = () => {
    // 位置
    // y = 相对viewbox坐标位置 + 路径在窗口的相对游戏左边位置
    const relateY =
      (((nextPoint[1] - point[1]) * (index - floorIndex) + point[1]) /
        Number(viewBox[3])) *
        pathRect.height +
      (pathRect.top - gameWrapRect.top) -
      (29 / 375) * innerWidth
    const relateX =
      (((nextPoint[0] - point[0]) * (index - floorIndex) + point[0]) /
        Number(viewBox[2])) *
        pathRect.width +
      (pathRect.left - gameWrapRect.left) -
      (66 / 375) * innerWidth
    return {top: relateY, left: relateX}
  }
  return getXY
}

// get --- 获取当前飞行距离所对应火箭角度
const getFlyDeg = (index) => {
  const floorIndex = Math.min(Math.floor(index), flyDistanceConfig - 2)
  if (floorIndex === 0) return 0
  // 定义两个点的坐标数组
  const point1 = flyListConfig[floorIndex]
  const point2 = flyListConfig[floorIndex + 1]

  // 提取两点的x坐标和y坐标
  const x1 = point1[0]
  const y1 = point1[1]
  const x2 = point2[0]
  const y2 = point2[1]

  // 计算直线的斜率
  const slope = (y2 - y1) / (x2 - x1)

  // 通过斜率计算直线与x轴正方向的夹角（弧度制）
  const angleRad = Math.atan(Math.abs(slope))

  // 将弧度制转换为角度制
  const angleDeg = angleRad * (180 / Math.PI)
  return -angleDeg
}

// elapsed 时间差值
// 每 100ms数组加1
// oddsLine 倍率数组
const getOdds = (elapsed, oddsLine) => {
  if (elapsed === 0) {
    return oddsLine[0]
  }
  const elapsedSec = elapsed / 100
  const cur = Math.floor(elapsedSec)
  if (cur > oddsLine?.length - 1) {
    return oddsLine[oddsLine?.length - 1]
  }
  return oddsLine[cur]
}

// enum --- subPageName
enum subPageName {
  排行榜 = 'RankModal',
  记录页 = 'RecordModal',
  规则页 = 'RuleModal',
}

// function -- 转化数字两位数
const getTwoNumFun = (num) => {
  return num > 9 ? String(num) : `0${num}`
}

const getNumImg = (key) => {
  const rewarsPng = require.context('./images/Rocket/norNum', false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}

const getBlueNumImg = (key) => {
  const rewarsPng = require.context(`./images/Rocket/blue`, false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
const getGreenNumImg = (key) => {
  const rewarsPng = require.context(`./images/Rocket/green`, false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
const getOrangeNumImg = (key) => {
  const rewarsPng = require.context(`./images/Rocket/orange`, false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
const getRedNumImg = (key) => {
  const rewarsPng = require.context(`./images/Rocket/red`, false)
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(key) !== -1
  })
  return src && rewarsPng(src)
}
let canScroll = true
const ScrollLock = (bool: boolean) => {
  canScroll = !bool
}
// 滚动到合适的位置，保持火箭距离下注8px
const ScrollBottom = () => {
  if (!canScroll) return
  const ele = document.getElementsByClassName('toastModal_scroll')[0]
  ele.scrollTop = ele.scrollHeight - ele.clientHeight
}

// 滚动到顶部
const ScrollTop = () => {
  if (!canScroll) return
  const ele = document.getElementsByClassName('toastModal_scroll')[0]
  ele.scrollTop = 0
}

// get --- 根据记录数获取对应颜色
// 1 返回 颜色text
// 2 返回 具体颜色
// 3 返回 图片
const getRecordColor = (index, type = 1, key = 'dian') => {
  if (!index) return '#ffffff'
  const maxColorIndex = recordColorConfig?.findIndex((ite) => {
    return ite >= index
  })
  if (maxColorIndex === -1) return recordColorTextConfig[0]
  switch (type) {
    case 1:
      return recordColorTextConfig[maxColorIndex]
      break
    case 2:
      return oddsColorConfig[maxColorIndex]
      break
    case 3:
      return {
        0: getBlueNumImg(key),
        1: getGreenNumImg(key),
        2: getOrangeNumImg(key),
        3: getRedNumImg(key),
      }[maxColorIndex]
      break
    default:
      return recordColorTextConfig[maxColorIndex]
      break
  }
}

// get --- 获取按钮状态
enum pageIndex {
  normal = 50,
  bg = 10,
  arrow = 20,
}

const getBtnStatus = (round_status: GameStatus, ite: betInfo, flyOdds: any) => {
  switch (round_status) {
    case GameStatus.bet:
      if (ite?.bet_odds) {
        return BtnStatusEnum.betGrey
      }
      return BtnStatusEnum.bet
      break
    case GameStatus.boom:
      // 没下注
      if (!ite?.bet_coins) {
        return BtnStatusEnum.betGrey
      }
      // 下注后
      return BtnStatusEnum.jumpGrey
      break
    case GameStatus.fly:
      // 没下注
      if (!ite?.bet_coins) {
        return BtnStatusEnum.betGrey
      }
      // 下注但已跳机 或者 倍率比下注大
      if (ite?.jump_odds || ite.bet_odds <= flyOdds) {
        return BtnStatusEnum.jumpGrey
      }
      // 其他
      return BtnStatusEnum.jump
      break
    default:
      return BtnStatusEnum.betGrey
      break
  }
}
// 默认下注倍率逻辑 首次按推荐 后续按照用户上一次
const getDefaultBet = () => {
  let local = {} as any
  try {
    if (window) {
      const left = JSON.parse(localStorage.getItem('RocketBetLeft') || '{}')
      const right = JSON.parse(localStorage.getItem('RocketBetRight') || '{}')
      local = {
        left,
        right,
      }
    }
  } catch (error) {
    //
  }
  return [
    {
      bet_odds: local?.left?.bet_odds || 0,
      bet_coins: local?.left?.bet_coins || 0,
    },
    {
      bet_odds: local?.right?.bet_odds || 0,
      bet_coins: local?.right?.bet_coins || 0,
    },
  ]
}

const setDefaultBet = (data) => {
  if (window) {
    if (data?.left) {
      localStorage.setItem('RocketBetLeft', JSON.stringify(data?.left))
    }
    if (data?.right) {
      localStorage.setItem('RocketBetRight', JSON.stringify(data?.right))
    }
  }
}

// 获取我的下注信息
const getOwnBetInfos = (own_bet_info) => {
  const bet_info = getDefaultBet()
  const cur_bet_info = own_bet_info?.map((ite, idx) => {
    return {
      ...ite,
      cur_bet_coins:
        ite?.cur_bet_coins ||
        ite?.bet_coins ||
        bet_info[idx]?.bet_coins ||
        ite?.default_bet_coins,
      cur_bet_odds:
        ite?.cur_bet_odds ||
        ite?.bet_odds ||
        bet_info[idx]?.bet_odds ||
        ite?.default_bet_odds,
    }
  })
  return cur_bet_info
}

// 动效图集合
const apngConfig = [
  TimeApng, // 火箭倒计时 0
  FireOneApng, // 尾焰A 1
  FireTwoApng, // 尾焰B 2
  PoFeng1Apng, // 破风A 3
  PoFeng2Apng, // 破风B 4
  BoomApng, // 火箭爆炸 5
  RightBetApng, // 右侧金币 6
  LeftBetApng, // 左侧金币 7
  RankBetApng, // 多人下注 8
  RocketApng, // 火箭本体 9
  RateToCoinsApng, // 倍率飞金币 10
  loadApng, // 11
  coinsChangeApng, // 金币变动apng 12
  FireThreeApng, // 尾焰C 13
  PoFeng3Apng, // 破风C 14
]

// 倍率对应文字 crazy  amazing excellent great  good
const oddToTextConfig = [15, 10, 5, 3, 1.5]
const oddToImg = [
  `${HostMaps.prod.img01}/img/png/id/295568501318`,
  `${HostMaps.prod.img01}/img/png/id/295568503708`,
  `${HostMaps.prod.img01}/img/png/id/295568503061`,
  `${HostMaps.prod.img01}/img/png/id/295568502407`,
  `${HostMaps.prod.img01}/img/png/id/295568501825`,
]

const audio = [
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/94/61/7549-c1ff-11ef-8a87-00163e04069f`, // 爆炸音效
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/8a/35/02e5-be7b-11ef-8a87-00163e04069f`, // 倍率飞金币音效
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/a9/1d/9666-be7b-11ef-8a87-00163e04069f`, // 倒计时音效 5播放
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/c3/68/bf64-be7b-11ef-845c-00163e0442bb`, // 下注音效
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/08/ae/0500-cf28-11ef-845c-00163e0442bb`, // 倒计时音效 大数
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/cd/31/8240-c68e-11ef-8a87-00163e04069f`, // 倒计时音效 1
  `${HostMaps.prod.img01}/download/file?obj=mefile/hyfo/a3/3c/3777-c903-11ef-845c-00163e0442bb`, // 文字提示音
]

const getOddText = (odd) => {
  const curIdx = oddToTextConfig?.findIndex((ite) => odd > ite)
  if (curIdx === -1) return undefined
  return oddToImg[curIdx]
}

const getAllNumImg = () => {
  const getImg = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'dian']
  const res = []
  const blue = require.context('./images/Rocket/blue/', false)
  const green = require.context('./images/Rocket/green/', false)
  const orange = require.context('./images/Rocket/orange/', false)
  const red = require.context('./images/Rocket/red/', false)
  getImg.forEach((v) => {
    res.push(blue(`./${v}.png`))
    res.push(green(`./${v}.png`))
    res.push(orange(`./${v}.png`))
    res.push(red(`./${v}.png`))
  })
  return res
}

// 获取当前声音状态 true 不播放 false 播放
const getMyMusic = () => {
  return !localStorage.getItem('greedyRocket_Music')
}

const setMyMusic = (status) => {
  localStorage.setItem('greedyRocket_Music', status)
}

const preloadOddsImg = () => {
  const imgList = [...getAllNumImg()]
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < imgList.length; i++) {
    const imgObj = new Image()
    imgObj.src = imgList[i]
  }
}
export {
  apngConfig,
  audio,
  flyDistanceConfig,
  flySpeedConfig,
  flyTimeConfig,
  getAllNumImg,
  getBlueNumImg,
  getBtnStatus,
  getDefaultBet,
  getFlyDeg,
  getFlyXY,
  getGreenNumImg,
  getMyMusic,
  getNumImg,
  getOdds,
  getOddText,
  getOrangeNumImg,
  getOwnBetInfos,
  getRecordColor,
  getRedNumImg,
  getTwoNumFun,
  logPath,
  oddToImg,
  oddToTextConfig,
  preloadOddsImg,
  renderRocketSvg,
  ScrollBottom,
  ScrollLock,
  ScrollTop,
  setDefaultBet,
  setMyMusic,
  subPageName,
  timeBigConfig,
}
